import { useNavigate } from 'react-router-dom';
import Loader from 'components/Loader';
import { LoadError } from 'components/LoadError';
import { has_permission } from 'config/permissions';
import { useAdminAuth } from 'hooks/useAdminAuth';
import { useGetShoppingCartQuery } from 'services/shoppingCartApi';
import { ActiveCartSummary } from './ActiveCartSummary';
import { CART_LOAD_ERROR } from './ShoppingCartDetail/constants';
import { CartStatusPrompt } from './CartStatusPrompt';

const ShoppingCart = () => {
  const navigate = useNavigate();
  const { clientId, activeRole, hasClient } = useAdminAuth();
  const canViewCart = has_permission('SHOPPING_CART_ROUTE', 'R', activeRole);
  const goToDetail = () => navigate('/shopping_cart_detail');

  // currentData (not data) so a client switch never briefly shows the previous
  // client's cart status while the new client's request is in flight.
  const {
    currentData: data,
    isFetching,
    isError,
    refetch,
  } = useGetShoppingCartQuery({ clientId: clientId ?? 0 }, { skip: !hasClient || !canViewCart });

  if (!activeRole) return null;

  if (!canViewCart) {
    return (
      <div className="content-full-width">
        <h1 className="title-permission">
          Sorry, you don&apos;t have permission to see this screen.
        </h1>
      </div>
    );
  }

  if (isError) return <LoadError message={CART_LOAD_ERROR} onRetry={refetch} />;

  const content = !hasClient ? (
    'Select a client to see their shopping cart.'
  ) : data?.cart ? (
    <ActiveCartSummary
      clientId={data.client_id}
      clientName={data.client_name}
      cart={data.cart}
      onEdit={goToDetail}
    />
  ) : (
    <CartStatusPrompt
      message={`${data?.client_name ?? 'This client'} does not have a Shopping Cart enabled currently. Would you like to enable a Shopping Cart?`}
      actionLabel="Enable Shopping Cart"
      onAction={goToDetail}
    />
  );

  return (
    <>
      {isFetching && <Loader type="dots" />}
      <div className="row filters-row shopping-cart-nav-spacer" />
      <div className="content-full-width shopping-cart-list-content">
        <div className="row custom-header-container">
          <div className="grid-column col-lg-9 col-md-8 col-sm-12 align-center">
            <span className="oath-h3 inkBlue">Shopping Cart</span>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">{!isFetching && content}</div>
        </div>
      </div>
    </>
  );
};

export default ShoppingCart;
